<template>
  <div class="list-jewels" v-if="items && items.length > 0">
    <div class="title">
      <span>{{ $t(section.toLowerCase()) }}</span>
    </div>
    <swiper class="swiper" :options="swiperOptions" ref="mySwiper">
      <div
        class="swiper-slide cursor-pointer"
        v-for="item in items"
        :key="item.sku"
        v-on:click="selectJewel(item)"
      >
        <div class="w-100 parent-img">
          <img :src="baseImageUrl + item.image" class="border-img" />
          <span class="jewel-name" v-if="item && item.minPrice">
            {{ item.name }}
            <br />
            {{ item.minPrice.toFixed(2).replace(".", ",") }}€
          </span>
        </div>
      </div>
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
    </swiper>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import "swiper/swiper-bundle.css";
import list from "../api/list";
import { mapGetters } from "vuex";
export default {
  name: "ListJewelsPreview",
  props: {
    section: String,
  },
  data() {
    return {
      baseImageUrl: process.env.VUE_APP_IMAGE_PATH,
      items: [],
      swiperOptions: {
        loop: false,
        paginationClicakble: true,
        breakpoints: {
          1024: {
            slidesPerView: 4,
            spaceBetween: 30,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 0,
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          320: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
        },
        // pagination: {
        //   el: ".swiper-pagination",
        //   clickable: true,
        // },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
  computed: {},
  mounted() {},
  created() {
    list.searchJewels(
      (searchJewel) => {
        this.items = searchJewel.data;
      },
      { jewelSection: [this.section] }
    );
  },
  methods: {
    ...mapMutations("detail", ["resetCurrentJewel", "resetDetail", "setPreselectedJewel"]),
    selectJewel(item) {
      this.resetDetail();
      this.setPreselectedJewel({});
      this.resetCurrentJewel();
      this.$router.push({
        name: "list.detail",
        params: {
          sku: item.sku,
        },
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.list-jewels {
  background-color: #eee;
  padding: 15px;
}
.title {
  text-align: left;
  margin-bottom: 10px;
  span {
    margin-left: 20px;
    background-color: white;
    margin-top: -30px;
    display: block;
    width: fit-content;
    padding: 5px 25px;
    border-radius: 80%;
    text-transform: uppercase;
    background-color: var(--secondary-color-1);
    color: white;
  }
}
.jewel-name {
  position: absolute;
  left: 0;
  right: 0;
  padding: 0px 50px;
  bottom: 20px;
  font-weight: normal;
  color: #3c3c3c;
  font-size: 12px;
  font-stretch: normal;
  font-style: normal;
}

.title-related {
  border-radius: 25px;
  background-color: var(--primary-color-1) !important;
  color: #fff !important;
  padding: 5px 40px;
  color: #fff;
  text-align: left;
  display: table;
  z-index: 999;
  margin-top: -20px;
}

.parent-img {
  border-radius: 50%;
  background-color: #ffff;
  padding: 20px;
}

.border-img {
  // width: 100%;
  border-radius: 50%;
  width: 100%;
  -moz-transform: scale(0.8);
  -webkit-transform: scale(0.8);
  transform: scale(0.8);
}

@media only screen and (min-width: 768px) {
  .swiper-slide {
    padding-top: 25px;
    padding-bottom: 25px;
    padding: 0px 0px;
  }
}

@media only screen and (max-width: 768px) {
  .swiper-slide {
    margin-right: 0px !important;
    padding: 0px 10px;
  }
  .jewel-name {
    font-size: 13px;
    padding: 0px 20px;
    bottom: 20px;
  }

  .parent-img {
    border-radius: 50%;
    background-color: #ffff;
    padding: 0px;
    position: relative;
  }

  .title-related {
    font-size: 10px;
    padding: 4px 20px;
    margin-top: -10px;
  }
  .border-img {
    width: 100%;
    object-fit: cover;
    border-radius: 0%;
    // margin-bottom: 5px;
    // height: 200px;
    -moz-transform: scale(0.6);
    -webkit-transform: scale(0.6);
    transform: scale(0.6);
    // box-shadow: 0px 1px 4px 0px #707070;
  }
}

.total-wrapper {
  background-color: #ebebeb;
}

.swiper-button-prev,
.swiper-button-next {
  color: var(--primary-color-1);
}

@media only screen and (max-width: 768px) {
  .total-wrapper {
    background-color: #ebebeb;
    margin-top: 10px;
    // height: 100px;
  }
}
</style>
